import tokens from 'config/constants/tokens'
import { Address } from './types'

const { bondly } = tokens

interface WarningToken {
  symbol: string
  address: Address
}

interface WarningTokenList {
  [key: string]: WarningToken
}

const SwapWarningTokens = <WarningTokenList>{
  bondly,
}

export default SwapWarningTokens
